import { useNavigate } from "react-router-dom";
import { useContext, useState, useEffect } from "react";
import { ThemeContext } from "../context/ThemeProvider";

export default function Header() {
  const navigate = useNavigate();
  const [currentDomain, setCurrentDomain] = useState("");

  const { theme, setTheme } = useContext(ThemeContext);

  const handleLogout = async () => {
    localStorage.clear();
    navigate("/login");
  };

  useEffect(() => {
    setCurrentDomain(window.location.hostname);
  }, []);

  function getLogoPath(currentDomain, theme) {
    const logos = {
      "mastercardjnk.vouch.club": (theme) =>
        theme ? "/images/J&KDarkLogo.png" : "/images/J&KLightLogo.png",
      "hccb.vouch.club": "/images/hccb_logo.png",
      "actiontesa.almonds.ai": "/images/action_tesa.jpg",
      "waaree.vouch.club": "/images/waaree.png",
    };

    console.log("currentDomain", currentDomain);

    const logo = logos[currentDomain];

    if (typeof logo === "function") {
      return logo(theme);
    }

    return (
      logo ||
      (theme ? "/images/almond-logo-dark.png" : "/images/almond-logo.png")
    );
  }

  return (
    <div className="header">
      <img
        className="header-logo"
        src={getLogoPath(currentDomain, theme)}
        alt=""
      />
      <div className="mc-header-buttons-container">
        <div
          className="mc-theme-toggle-button-container"
          onClick={() => {
            setTheme(!theme);
          }}
        >
          {theme ? (
            <i class="fa-solid fa-sun"></i>
          ) : (
            <i class="fa-solid fa-moon"></i>
          )}
        </div>
        <button className="btn btn-logout" onClick={handleLogout}>
          <i class="fa-solid fa-arrow-right-from-bracket"></i>
          <span className="mc-logout-button-text">Logout</span>
        </button>
      </div>
    </div>
  );
}
